import { createContext, useContext, useState, useCallback } from 'react';

interface NotificationContextType {
  showHelpNotification: boolean;
  notificationTarget: string | null;
  triggerNotification: (buttonId: string) => void;
  hideNotification: () => void;
}

const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

export const NotificationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [showHelpNotification, setShowHelpNotification] = useState(false);
  const [notificationTarget, setNotificationTarget] = useState<string | null>(null);

  const triggerNotification = useCallback((buttonId: string) => {
    setNotificationTarget(buttonId);
    setShowHelpNotification(true);
    
    // Auto-ocultar después de 8 segundos
    setTimeout(() => {
      setShowHelpNotification(false);
      setNotificationTarget(null);
    }, 8000);
  }, []);

  const hideNotification = useCallback(() => {
    setShowHelpNotification(false);
    setNotificationTarget(null);
  }, []);

  return (
    <NotificationContext.Provider 
      value={{ 
        showHelpNotification, 
        notificationTarget,
        triggerNotification, 
        hideNotification
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotification must be used within NotificationProvider');
  }
  return context;
};